import { Connection1cFormDto, type Connection1cFormInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-form.dto';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';

import * as yup from 'yup';

/** 1C ERP database connection credentials response body */
export interface Connection1cFindInterface extends Connection1cFormInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Companies using this 1C ERP database. A company may only use one such database. */
  companies?: CompanyFindInterface[];
}

/** 1C ERP database connection credentials response body - DTO schema */
export const Connection1cFindDto = SerdeDtoClass.from<Connection1cFormInterface, Connection1cFindInterface>(
  Connection1cFormDto,
  IntergrationDtoKeyEnum.CONNECTION_1C_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  companies: {
    optional: true,
    label: 'Компании',
    serializer: yup.array(yup.object({
      id: yup.number(),
      name: yup.string(),
      inn: yup.string(),
      kpp: yup.string(),
    })) as yup.Schema<any>,
  },
});
